import { openCompanyDetailsModal } from '@hotjar/checkout';
import { isZuoraEnabled, isBillingV3Enabled } from '@hotjar/webapp/domains/billing/features';

angular.module('hjSettingsModule').controller('InvoicesCtrl', [
    '$scope',
    '$q',
    'Account',
    'Help',
    'ModalUpdatePurchaseOrder',
    'Notify',
    'Restangular',
    'restDefaultHandlers',
    'User',
    'VAT',
    'UserData',
    'Feature',
    function (
        $scope,
        $q,
        Account,
        Help,
        ModalUpdatePurchaseOrder,
        Notify,
        Restangular,
        restDefaultHandlers,
        User,
        VAT,
        UserData
    ) {
        /*************************
         * PRIVATE VARIABLES
         *************************/
        var account = Account.getOwned(),
            rAccount = Restangular.one('accounts', account && account.id),
            rAccountInvoices = rAccount.all('invoices'),
            rEmailRecipients = rAccount.one('email-recipients'),
            user = User.get(),
            promises = [],
            zuoraEnabled = isZuoraEnabled(account);

        /*************************
         * PRIVATE FUNCTIONS
         *************************/

        /**
         * Get this account's invoices.
         */
        function getInvoices() {
            return rAccountInvoices.getList().then(function (res) {
                $scope.model.invoices = res;
                $scope.model.invoicesByStatus = _.groupBy(res, 'status');
                $scope.model.outstandingInvoice = _.head($scope.model.invoicesByStatus.unpaid);
            }, restDefaultHandlers.onError);
        }

        /**
         * Get recipients for this account.
         */
        function getEmailRecipients() {
            return rEmailRecipients.get().then(function (res) {
                if (res.success) {
                    $scope.model.emailRecipients = res.email_recipients;
                } else {
                    Notify.unhandledError();
                }
            }, restDefaultHandlers.onError);
        }

        /**
         * Get company details for this account.
         */
        function getCompanyDetails() {
            account = Account.getOwned();

            $scope.model.companyDetails = {
                company: account.company,
                address: account.address,
                countryCode: account.location && account.location.split(',')[1],
                vatNumber: account.vat_number
            };
        }

        /**
         * Initialize.
         */
        function init() {
            if ($scope.model.isAccountAdmin) {
                promises.push(getInvoices());
                promises.push(getEmailRecipients());
                getCompanyDetails();
            }

            $q.all(promises).then(
                function () {
                    $scope.model.loaded = true;
                },
                function (res) {
                    restDefaultHandlers.onError(res);
                }
            );
        }

        /*************************
         * SCOPE VARIABLES
         *************************/
        $scope.model = {
            outstandingInvoice: null,
            invoicesByStatus: null,
            loaded: false,
            isAccountAdmin: user.flags.isAccountAdmin,
            invoices: [],
            emailRecipients: [],
            companyDetails: {
                company: '',
                address: '',
                countryCode: '',
                vatNumber: null
            },
            hasManualPaymentMethod: account.billing_cycle === 'yearly',
            isBillingV3Customer: isBillingV3Enabled(account)
        };

        /*************************
         * INITIALIZATION
         *************************/
        init();

        /*************************
         * SCOPE FUNCTIONS
         *************************/
        $scope.newBillingPaymentTicket = function newBillingPaymentTicket() {
            Help.newBillingPaymentTicket('Change Billing and Payment');
        };
        $scope.openBillingPaymentChat = function openBillingPaymentChat() {
            Help.openChat('newBillingPaymentTicket', 'Change Billing and Payment');
        };

        /**
         * Show the company details modal.
         */
        $scope.showEditCompanyDetails = function () {
            return openCompanyDetailsModal({ account }).then(
                (data) => {
                    if (zuoraEnabled) {
                        console.log('TODO: Implement zuora endpoint for updating details here', data);
                    }

                    UserData.refreshFromServer(getCompanyDetails);
                },
                () => undefined
            );
        };

        /**
         * Check if VAT applies for the Company's country.
         */
        $scope.isVatCountry = function () {
            return VAT.appliesToCountry($scope.model.companyDetails.countryCode);
        };

        /**
         * Show the modal to update a purchase order number.
         *
         * @param invoice Invoice to update Purchase Number for.
         */
        $scope.showUpdatePurchaseOrderNumber = function (invoice) {
            ModalUpdatePurchaseOrder.show(invoice)
                .then(_.partial(ModalUpdatePurchaseOrder.updatePurchaseOrderNumber, account, invoice))
                .catch(_.noop);
        };
    }
]);
